import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout.jsx";
import ProtectedOutlet from "./components/ProtectedOutlet.jsx";
import Home from "./pages/Home.jsx";
import ProtocolHealth from "./pages/ProtocolHealth.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import Deposit from "./pages/Deposit.jsx";
import MyTds from "./pages/MyTds.jsx";
import TdDetail from "./pages/TdDetail.jsx";
import AbandonedRecovery from "./pages/AbandonedRecovery.jsx";
import MyLoans from "./pages/MyLoans.jsx";
import LoanDetail from "./pages/LoanDetail.jsx";
import Lending from "./pages/Lending.jsx";
// Turbo page is hidden in V6.2 — leverage capability comes via the
// per-deposit Turbo product picker on the Deposit page and the CYR
// pool sweep, not via a standalone /loans/turbo route. The source
// remains in repo for future re-enabling.
// import Turbo from "./pages/Turbo.jsx";
import Reinvest from "./pages/Reinvest.jsx";
import MyTokens from "./pages/MyTokens.jsx";
import Marketplace from "./pages/Marketplace.jsx";
import Activity from "./pages/Activity.jsx";
import Settings from "./pages/Settings.jsx";
import Support from "./pages/Support.jsx";
import Faq from "./pages/Faq.jsx";
import SystemActivity from "./pages/SystemActivity.jsx";
import NotFound from "./pages/NotFound.jsx";

/**
 * Top-level router. Each public route is wrapped by Layout which renders
 * the navbar, footer and global wallet status banner. Everything
 * reachable from the sidebar lives under `<ProtectedOutlet>` so a visit
 * without a connected wallet redirects to Home (and pops the connect
 * modal) instead of rendering the protected page.
 */
export default function App() {
    return (
        <Routes>
            {/* Unlisted standalone ops page — no sidebar/nav, no wallet needed,
                so a direct link is safe to share with the client. Not linked
                anywhere in the app; rename the path here for more obscurity. */}
            <Route path="/system-activity" element={<SystemActivity />} />

            <Route element={<Layout />}>
                {/* Public — no wallet required */}
                <Route index element={<Home />} />
                <Route path="protocol-health" element={<ProtocolHealth />} />
                {/* Support is static, wallet-independent FAQ/reference content,
                    so it lives in the public group and backs the public "FAQ"
                    nav/footer links. */}
                <Route path="support" element={<Support />} />
                {/* Comprehensive FAQ — full reproduction of the GILDer FAQ
                    document (with its infographics), backing the public
                    "FAQ" link in the top navigation. */}
                <Route path="faq" element={<Faq />} />
                <Route path="404" element={<NotFound />} />

                {/* Protected — wallet required */}
                <Route element={<ProtectedOutlet />}>
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="deposit" element={<Deposit />} />
                    <Route path="term-deposits" element={<MyTds />} />
                    <Route path="term-deposits/recovery" element={<AbandonedRecovery />} />
                    <Route path="term-deposits/:id" element={<TdDetail />} />
                    <Route path="loans" element={<MyLoans />} />
                    <Route path="loans/lending" element={<Lending />} />
                    <Route path="loans/:id" element={<LoanDetail />} />
                    {/* `loans/turbo` route hidden — see import note above. */}
                    <Route path="reinvest" element={<Reinvest />} />
                    <Route path="my-tokens" element={<MyTokens />} />
                    <Route path="marketplace" element={<Marketplace />} />
                    <Route path="activity" element={<Activity />} />
                    <Route path="settings" element={<Settings />} />
                </Route>

                <Route path="*" element={<Navigate to="/404" replace />} />
            </Route>
        </Routes>
    );
}
